// @react
import React from 'react'
import { useMediaQuery } from '@material-ui/core'
// @libraries
import DocumentTitle from 'react-document-title'
import Container from '@bit/atd.web.container'
import Grid from '@bit/atd.web.grid'
import config from 'constants/config'
// @components
import Spacer from '@bit/atd.web.spacer'
import theme from '@bit/atd.web.theme'
// @module components
import MyATDPageWrapper from 'modules/common/components/MyATDPageWrapper'
import Profile from 'modules/dashboard/components/Profile'
import FeaturedContent from 'modules/dashboard/components/FeaturedContent'
import LearningActivity from 'modules/dashboard/components/LearningActivity'
import Membership from 'modules/dashboard/components/Membership'
import Network from 'modules/dashboard/components/Network'
import RecommendedContent from 'modules/dashboard/components/RecommendedContent'
import CapabilityModel from 'modules/dashboard/components/CapabilityModel'
import Topics from 'modules/dashboard/components/Topics'
import UserContent from 'modules/dashboard/components/UserContent'
import Reminder from 'modules/common/components/Reminder'
import WelcomeModal from 'modules/dashboard/components/WelcomeModal'
import { ReactElement } from 'react'
import BenefitsResources from '../../components/BenefitsResources'

/**
 * 2.0 MyATD - Dashboard
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=866%3A3045
 */

/**
 *
 * @param props
 * @constructor
 */
const Dashboard = (): ReactElement => {
  /******************************************
   * HOOKS
   ******************************************/

  const isMobile = useMediaQuery(
    theme.breakpoints.down('sm'),
    config.mediaQuery,
  )
  const isTablet = useMediaQuery('(min-width:768px) and (max-width: 1023px)')

  /******************************************
   * RENDER
   ******************************************/

  const desktopLayout = (
    <>
      <Grid item xs={3}>
        <Grid container>
          <Grid item xs>
            <Grid item xs={12}>
              <Profile />
            </Grid>

            <Grid item xs={12}>
              <Spacer size={24} />
              <Topics />
            </Grid>

            <Grid item xs={12}>
              <Spacer size={24} />
              <BenefitsResources />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={6}>
        <Grid container>
          <Grid item xs={12}>
            <CapabilityModel />
          </Grid>

          <Grid item xs>
            <Spacer size={24} />
            <LearningActivity />
          </Grid>

          <Grid item xs={12}>
            <Spacer size={24} />
            <FeaturedContent />
          </Grid>

          <Grid item xs={12}>
            <Spacer size={24} />
            <RecommendedContent />
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={3}>
        <Grid container>
          <Grid item xs={12}>
            <Membership />
          </Grid>

          <Grid item xs={12}>
            <Spacer size={24} />
            <Network />
          </Grid>

          <Grid item xs={12}>
            <Spacer size={24} />
            <UserContent />
          </Grid>
        </Grid>
      </Grid>
    </>
  )

  const tabletLayout = (
    <>
      <Grid item xs={4}>
        <Grid container>
          <Grid item xs>
            <Grid item xs={12}>
              <Profile />
            </Grid>

            <Grid item xs={12}>
              <Spacer size={24} />
              <Membership />
            </Grid>

            <Grid item xs={12}>
              <Spacer size={24} />
              <Topics />
            </Grid>

            <Grid item xs={12}>
              <Spacer size={24} />
              <BenefitsResources />
            </Grid>

            <Grid item xs={12}>
              <Spacer size={24} />
              <Network />
            </Grid>

            <Grid item xs={12}>
              <Spacer size={24} />
              <UserContent />
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={8}>
        <Grid container>
          <Grid item xs={12}>
            <CapabilityModel />
          </Grid>

          <Grid item xs>
            <Spacer size={24} />
            <LearningActivity />
          </Grid>

          <Grid item xs={12}>
            <Spacer size={24} />
            <FeaturedContent />
          </Grid>

          <Grid item xs={12}>
            <Spacer size={24} />
            <RecommendedContent />
          </Grid>
        </Grid>
      </Grid>
    </>
  )

  const mobileLayout = (
    <>
      <Grid item xs={12}>
        <Profile />
      </Grid>

      <Grid item xs={12}>
        <Membership />
      </Grid>

      {/*<Grid item xs>*/}
      {/*  <LearningActivity />*/}
      {/*</Grid>*/}

      <Grid item xs={12}>
        <CapabilityModel />
      </Grid>

      <Grid item xs={12}>
        <RecommendedContent />
      </Grid>

      <Grid item xs={12}>
        <Topics />
      </Grid>

      {/* DO NOT DELETE */}
      {/*<Grid item xs={12}>*/}
      {/*  <BenefitsResources />*/}
      {/*</Grid>*/}

      <Grid item xs={12}>
        <Network />
      </Grid>

      <Grid item xs={12}>
        <UserContent />
      </Grid>
    </>
  )

  /**
   * props
   */
  return (
    <MyATDPageWrapper>
      <DocumentTitle title="Dashboard | ATD">
        <Container>
          <Reminder isHiddenComponent={<Spacer size={!isMobile ? 32 : 24} />} />

          <Grid container spacing={3}>
            {isMobile
              ? isTablet
                ? tabletLayout
                : mobileLayout
              : desktopLayout}
            <WelcomeModal />
          </Grid>
        </Container>
      </DocumentTitle>
    </MyATDPageWrapper>
  )
}

export default Dashboard
